<div class="ecatelog-mobile" id="scrollableElement">
    <!-- product search box -->
    <div class="ecatelog-mobile__search">
        <nz-tabset [nzSelectedIndex]="searchTabsIndex" (nzSelectedIndexChange)="changeSearchTab($event)" >
            <nz-tab [nzTitle]="'VIN_NO'| translate">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input_mobile">
                    <input 
                        (click)="handleSearchVin()"
                        nz-input 
                        readonly
                        type="text" 
                        [(ngModel)]="vinSearchValue"
                        [placeholder]="'SEARCH_BY_VIN_NUMBER' | translate" 
                    />
                    <ng-template #suffixTemplateInfo>
                      <svg-icon [iconName]="'new/ui-ic-search-blue.svg'"></svg-icon>
                    </ng-template>
                </nz-input-group>
            </nz-tab>
            <nz-tab [nzTitle]="'VEHICLE'| translate">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input_mobile">
                    <input 
                        (click)="handleSearchVehicle()"
                        nz-input 
                        readonly
                        type="text" 
                        [(ngModel)]="vehicleSearchValue"
                        [placeholder]="'SEARCH_FOR_VEHICLE' | translate" 
                    />
                    <ng-template #suffixTemplateInfo>
                        <svg-icon [iconName]="'new/ui-ic-search-blue.svg'"></svg-icon>
                    </ng-template>
                </nz-input-group>
            </nz-tab>
            <nz-tab [nzTitle]="'PRODUCT'| translate">
                <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input_mobile">
                    <input 
                        (click)="handleSearchByCompany()"
                        nz-input 
                        readonly
                        type="text" 
                        [(ngModel)]="companySearchValue"
                        [placeholder]="'SEARCH_BY_MANY' | translate" 
                    />
                    <ng-template #suffixTemplateInfo>
                        <svg-icon [iconName]="'new/ui-ic-search-blue.svg'"></svg-icon>
                    </ng-template>
                </nz-input-group>
            </nz-tab>
        </nz-tabset>
    </div>
    <!-- product list -->
    <div class="ecatelog-mobile__content">
        <div [ngClass]="stickyTop ? 'fixed top-0 left-0 w-full px-3 bg-[#EFF1F2]': 'relative'">
            <div class="product-list__category" *ngIf="vehicle?.length > 0 && type === 'vin'">
                <div class="product-list__category-name">
                    <svg-icon [iconName]="'new/car.svg'"></svg-icon>
                    <span>Selected</span>
                    <span class="labels flex-center" (click)="handleOpenVinResultList()">
                        {{ vehicle?.length }} {{'LABELS' | translate}} 
                        <i nz-icon nzType="right" nzTheme="outline" class="color-blue"></i>
                    </span>
                </div>
            </div>
            <div *ngIf="vehicle?.length > 0 && vinResultListVisible" class="mb-2">
                <div class="search-input__result-item" *ngFor="let item of vehicle;">
                    <label 
                        size="small" 
                        nz-checkbox 
                        [(ngModel)]="item.checked" 
                        (ngModelChange)="handleChangeCarList()"
                        class="items-center"
                    >{{ item.carName }}</label>
                </div>
            </div>
            <div class="product-list__category">
                <div class="product-list__category-name">
                    <svg-icon [iconName]="'new/filter.svg'"></svg-icon>
                    <span>{{'CATEGORY' | translate }}</span>
                    <span class="labels flex-center" (click)="handleViewAllType()">
                        {{ category?.length || 0 }} {{'LABELS' | translate}} 
                        <i nz-icon nzType="right" nzTheme="outline" class="color-blue"></i>
                    </span>
                </div>
                <div>{{ pagination.total }} {{'RESULTS' | translate }}</div>
            </div>
            <div class="drawer-tags mb-2">
                <nz-tag class="category-tag" *ngFor="let item of category;" nzMode="closeable" (nzOnClose)="handleRemoveCategory(item)">{{ item }}</nz-tag>
            </div>
        </div>
        <div class="product-list">
            
            <div class="product-item" *ngFor="let data of productList" >
                <img 
                    *ngIf="data.images.length > 0" 
                    [src]="data.images[0].imageURL100" 
                    class="product-item__img" 
                    (click)="goDetail(data)"
                    alt=""
                />
                <img 
                    *ngIf="!data.images?.length"  
                    (click)="goDetail(data)"
                    src="assets/picture.svg" 
                    class="product-item__img"
                />
                <div  class="product-item__content">
                    <div  class="product-item__title mb-2"  (click)="goDetail(data)">
                        {{ data.genericArticles[0].genericArticleDescription }} 
                        <span *ngIf="data.misc?.additionalDescription">
                             |  {{ data.misc?.additionalDescription }}
                        </span>
                    </div>
                    <div class="product-item__number mb-2">{{ data.articleNumber }}</div>
                    <div class="status-tag-box mb-2">
                        
                        <span [ngClass]="['status-tag',  getProductTypeTagColor(data.misc?.articleStatusDescription)]">{{ data.misc?.articleStatusDescription }}</span>
                
                        <span class="status-tag danger" *ngIf="!data?.stockQty">{{'NO_STOCK' | translate }}</span>
                        <span class="status-tag waring" *ngIf="data?.stockQty && data?.quantity > data?.stockQty">{{'LOW_STOCK' | translate }}</span>
                        <span class="status-tag success" *ngIf="data?.stockQty && data?.quantity <= data?.stockQty">{{'IN_STOCK' | translate }}</span>
                      </div>
                    <div class="">
                        Trade No.
                        <div class="">
                            <span 
                                class="trade" 
                                *ngFor="let trade of data?.tradeNumbers; let last = last" 
                                (click)="search(trade, $event)">
                                {{trade}}{{ !last ? ' / ' : '' }}
                            </span>
                        </div>
                    </div>
                    <div class="product-item__quantity" (click)="handleClickQuantityBox($event)">
                        <div>
                          <span class="pr-2">MOQ </span> {{ data.minumQty }}
                        </div>
                        <div class="quantity-number">
                            <span class="minus" (click)="decrease(data)" *ngIf="data?.mobileQuantity >= 0 && !data?.quantityIsZero">
                                <span nz-icon nzType="minus" nzTheme="outline"></span>
                            </span>
                            <nz-input-number 
                                *ngIf="data?.mobileQuantity >= 0 && !data?.quantityIsZero"
                                class="quantity" 
                                [(ngModel)]="data.mobileQuantity" 
                                [nzMin]="0"  
                                [nzStep]="data.minumQty"
                                (nzBlur)="handleChangeQuantity(data)"
                            ></nz-input-number>
                            <span class="plus" (click)="increase(data)">
                                <span nz-icon nzType="plus" nzTheme="outline"></span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <nz-empty nzNotFoundImage="simple" *ngIf="productList?.length === 0"></nz-empty> 
        </div>
        <div class="product-list__pagination" (click)="handleLoadProductList()" *ngIf="showLoadingMore">
            <a nz-button nzType="link" [nzLoading]="isSpinning" >加载更多~</a>
        </div>
    </div>
    <!-- product fix button -->
    <div class="ecatelog-mobile__footer" [ngClass]="isScrollBottom ? 'relative': 'fixed left-0 bottom-0'">
        <div class="footer-buttons">
            <div class="footer-buttons__item  default" (click)="handleToggleSelectProductDrawer()">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M15.4769 2H5.25V22H19.25V6.31213L15.4769 2ZM15.75 3.83071L17.6481 6H15.75V3.83071ZM6.25 21V3H14.75V7H18.25V21H6.25ZM7.25 9H15.25V10H7.25V9ZM7.25 11.5H15.25V12.5H7.25V11.5ZM7.25 14H12.25V15H7.25V14Z" fill="#006EAD"/>
                </svg>
                <div class="flex-grow-[2] ml-2">
                    <div class="flex justify-between">
                        <span>{{ 'MATERIAL_NO' | translate }}</span>
                        <span class="color-blue">{{ materialNo }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span>{{ 'MATERIAL_TYPE' | translate }}</span>
                        <span class="color-blue">{{ materialType }}</span>
                    </div>
                </div>
            </div>
            <button 
                nz-button 
                nzSize="large" 
                nzType="primary"
                class="footer-buttons__item primary"
                [ngClass]="{'disabled':!isLogin || userData?.queryUserPageInfoResDTO?.status!==2 || selectedProductList?.length === 0}"
                [disabled]="!isLogin || userData?.queryUserPageInfoResDTO?.status !== 2 || selectedProductList?.length ===0" 
                (click)="handleAddCart($event)"
                nzBlock
                >
                <svg-icon [isUrl]="false" [iconName]="'cart.svg'" class="mr6" [size]="20"></svg-icon>
                <span>{{'ADD_TO_CART' | translate }}</span>
            </button>
        </div>
    </div>


    <div class="ecatelog-mobile__selected" [ngStyle]="{'display': selectedProductListVisible ? 'block' : 'none'}">
        <div class="ecatelog-mobile__mask" (click)="handleToggleSelectProductDrawer()"></div>
        <div 
            class="ecatelog-mobile__drawer" 
        >
            <div class="px-2 py-4">
                <div class="flex justify-between mb-4">
                    <label nz-checkbox [(ngModel)]="checkedAll" class="font-bold" (ngModelChange)="handleSelectAll()">{{'CART_SELECT' | translate}}</label>
                    <svg-icon *ngIf="showDeleteIcon" [iconName]="'new/delete.svg'" (click)="handleRemoveSelect()"></svg-icon>
                </div>
                <div class="product-item" *ngFor="let data of selectedProductList">
                    <label nz-checkbox [(ngModel)]="data.checked" class="font-bold"></label>
                    <img 
                        *ngIf="data.images.length > 0" 
                        [src]="data.images[0].imageURL100" 
                        class="product-item__img" 
                        alt=""
                    />
                    <img *ngIf="!data.images?.length"  src="assets/picture.svg" class="product-item__img"/>
                    <div  class="product-item__content">
                        <div  class="product-item__title mb-2">
                            {{ data.genericArticles[0].genericArticleDescription }} 
                            <span *ngIf="data.misc?.additionalDescription">
                                |  {{ data.misc?.additionalDescription }}
                            </span>
                        </div>
                        <div class="product-item__number mb-2">{{ data.articleNumber }}</div>
                        <div class="status-tag-box mb-2">
                            <span class="status-tag">{{ data.misc?.articleStatusDescription }}</span>
                    
                            <span class="status-tag danger" *ngIf="!data?.stockQty">{{'NO_STOCK' | translate }}</span>
                            <span class="status-tag waring" *ngIf="data?.stockQty && data?.quantity > data?.stockQty">{{'LOW_STOCK' | translate }}</span>
                            <span class="status-tag success" *ngIf="data?.stockQty && data?.quantity <= data?.stockQty">{{'IN_STOCK' | translate }}</span>
                        </div>
                        <div class="">
                            Trade No.
                            <div class="">
                                <span 
                                    class="trade" 
                                    *ngFor="let trade of data?.tradeNumbers; let last = last" 
                                    (click)="search(trade, $event)">
                                    {{trade}}{{ !last ? ' / ' : '' }}
                                </span>
                            </div>
                        </div>
                        <div class="product-item__quantity">
                            <div>
                            <span class="pr-2">MOQ </span> {{ data.minumQty }}
                            </div>
                            <div class="quantity-number">
                                <span class="minus" (click)="decrease(data)" *ngIf="data?.mobileQuantity > 0">
                                    <span nz-icon nzType="minus" nzTheme="outline"></span>
                                </span>
                                <nz-input-number 
                                    *ngIf="data?.mobileQuantity > 0"
                                    class="quantity" 
                                    [(ngModel)]="data.mobileQuantity" 
                                    [nzMin]="0"  
                                    [nzStep]="data.minumQty"
                                    (nzBlur)="handleChangeQuantity(data)"
                                ></nz-input-number>
                                <span class="plus" (click)="increase(data)">
                                    <span nz-icon nzType="plus" nzTheme="outline"></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div> 

                <nz-empty nzNotFoundImage="simple" *ngIf="selectedProductList?.length === 0"></nz-empty> 
            </div>
        </div>
    </div>
</div>


<app-product-mobile-category (selectCategory)="handleSelectCategory($event)"></app-product-mobile-category>



